import { mapActions, mapGetters } from "vuex";
export default {
  computed: {
    ...mapGetters(['getAllGameResetIndex', 'getResetExgame'])
  },
  watch: {
    getAllGameResetIndex: 'getAllGame',
    getResetExgame: 'getpmtge'
  },
  created () {
    this.getAllGame()
    this.getpmtge()
  },
  methods: {
    ...mapActions(['setAllGame', 'setExgame']),
    async getAllGame () {
      try {
        let res = await this.$axios.gameLobby.gamelist()
        if ('status' in res && res.status === 0) return
        this.setAllGame(res)
      } catch (error) {
        console.error(error)
      }
    },
    async getpmtge () {
      try {
        const gamefirmList = await this.$axios.cq9.getElectronicGameMaker()
        const res = await this.$axios.cq9.getpmtge()
        const exgameList = res.map(it => {
          it['gamehall'] = it.gamename.split('-')[0]
          it.id = it.gametypeid
          const gamefirm = gamefirmList.filter(item => item.idop == 1).find(item => item.gamehall.toLowerCase() == it.gamehall.toLowerCase())
          it.catenaId = gamefirm ? gamefirm.hallsid : null
          return it
        }).filter(it => it.catenaId)
        this.setExgame(exgameList)
      } catch (error) {
        console.log(error);
      }
    },
  },
}